<template>
    <div class="dropdown">
        <select v-model="newValue" :name="name" :disabled="disabled
">
            <option v-for="(item, index) in items" :value="item.value" v-bind:key="index">{{item.label}}</option>
        </select>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'dropdown',
    mixins: [
        Default
    ],
    props: ['name', 'placeholder', 'value', 'items', 'disabled'],
    data() {
        return {
            newValue: ''
        };
    },
    created() {
        this.newValue = this.value;
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    }
};
</script>

<style lang="scss" scoped>
    .dropdown {
        position: relative;
        display: block;
        height: 1.5em;
        line-height: 1.5;
        padding: 0 1.5em 0 0;
        width: max-content;

        $border-radius: .25em;
        $after-width: 1.5em;
        select {
            outline: 0;
            box-shadow: none;
            border: 1px solid grey;
            -webkit-border-radius: $border-radius;
            -moz-border-radius: $border-radius;
            border-radius: $border-radius;

            /*min-width: calc(4em + 1.5em);*/
            /*width: max-content;*/
            height: 100%;
            margin: 0;
            padding: 0 .5em 0 .5em;
            color: #000;
            cursor: pointer;

            &:hover {
                border: 1px solid $primary-color;
            }

            &:disabled {
                background-color: lightgray;
                color: gray;
                cursor: default;
                border: 1px solid gray;
            }
        }
    }
</style>